import React from 'react'

function TestRequest() {
  return (
    <div>Test Requests (from OPD/IPD doctors)</div>
  )
}

export default TestRequest